module.exports = __webpack_public_path__ + "img/34_53.a9ab5ee9.png";